























import { defineComponent } from '@vue/composition-api';
import { Scrollbar } from '@/app/components';

export default defineComponent({
    name: 'Overview',
    metaInfo: { title: 'Overview' },
    components: {
        Scrollbar,
    },
    setup() {},
});
